import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../../firebase';

export default function AboutSection() {
  const [aboutData, setAboutData] = useState({
    title: 'Mutlu Yaşamın Yeni Adresi',
    storyPart1: 'KARE YAPI İNŞAAT sizin ve ailenizin yaşam kalitesini yükseltecek özelliklerde projelendirildi. En ince detayına kadar özenle ve kusursuz çözümlenerek size konforlu bir yaşam sunuyor.',
    storyPart2: 'Geneli 2+1 ve 3+1\'den oluşan daire konseptiyle 30 m² ve 120 m² teras alanlarıyla, huzurlu bir yaşam alanına davet ediyor. Metro ve Marmaraya 2 dakika yürüme mesafesinde olup dairenizin değerine değer katan bir yaşam sunuyoruz.'
  });

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'pages', 'about'), (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        
        const fallbackP1 = 'KARE YAPI İNŞAAT, 15 yılı aşkın süredir Türkiye\'nin inşaat sektöründe kalite, güven ve mimari estetiği yeniden tanımlayan köklü bir A Sınıfı Müteahhitlik markasıdır. Kurulduğumuz ilk günden bu yana, sadece binalar değil; nesilden nesile güvenle aktarılacak devasa yaşam merkezleri, prestijli ticari alanlar ve mutlu aile yuvaları inşa ediyoruz.';
        const fallbackP2 = 'Her projemizde "İnsan Odaklı Gelişim" felsefesini kalbimize koyuyor, İstanbul\'un en değerli lokasyonlarında arazinin ruhuna uygun, doğayla barışık ve en ileri mühendislik teknolojilerini kullanan anıtsal yapılar yükseltiyoruz. Bizim için bir inşaat; beton ve demirden ibaret değil, uzun ömürlü bir sanat eseridir.';

        const isCorruptP1 = data.storyPart1 && data.storyPart1.includes('KARE YAPI İNŞAAT, sektördeki köklü geçmişi');
        const isCorruptP2 = data.storyPart2 && data.storyPart2.includes('Her projemizde "önce insan"');

        setAboutData({
          title: data.title || 'Mutlu Yaşamın Yeni Adresi',
          storyPart1: isCorruptP1 ? fallbackP1 : (data.storyPart1 || fallbackP1),
          storyPart2: isCorruptP2 ? fallbackP2 : (data.storyPart2 || fallbackP2)
        });
      }
    });
    return () => unsub();
  }, []);

  return (
    <div className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          {/* Image */}
          <div className="relative rounded-xl overflow-hidden shadow-2xl group">
            <img
              src="/tk-int-ref-1.png"
              alt="KARE YAPI İNŞAAT"
              className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-700"
            />
          </div>

          {/* Content */}
          <div className="text-white">
            <div 
              className="text-red-500 text-lg font-semibold mb-2"
              style={{ fontFamily: 'Raleway, sans-serif' }}
            >
              KARE YAPI İNŞAAT
            </div>
            <h2 className="text-4xl font-bold mb-6">{aboutData.title}</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>{aboutData.storyPart1}</p>
              <p>{aboutData.storyPart2}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}